module.exports = __webpack_public_path__ + "static/media/Activity.5215b8e7.png";